import React from 'react';
import ReactDOM from 'react-dom';
import querystring from 'querystring';
import geckoAuth from 'services/gecko-auth';
import TagManager from 'react-gtm-module';
import * as Sentry from '@sentry/react';

//CSS
// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
// FontAwesome Pro
import '@fortawesome/fontawesome-pro/css/all.css';
// Gecko UI
import './ui/css/global.scss';
// Custom
import './App.scss';
// Polyfills
import './utilities/polyfills';

import { GeckoGlobal } from './ui';

import './services/export-service';

// Set up Redux
import { Provider } from 'react-redux'; // https://github.com/reactjs/react-redux
import { reduxStore } from 'services/gecko-store/redux.js';

// Set up Router
import Router from 'universal-router'; // https://github.com/kriasoft/universal-router/blob/master/docs/api.md
import routes from './routes';
import App from './App.jsx';

import GeckoLocation from './services/gecko-location';
import GeckoStore from 'services/gecko-store';
import { CONSTS } from 'constants/index.js';

if (process.env.NODE_ENV === 'production') {
  try {
    Sentry.init({
      dsn: 'https://7cb05a62f887443f888270908058d72a@sentry.io/201073',
    });
  } catch (error) {
    console.error(error);
  }
}

const getFacebookConfig = () => ({
  appId: process.env.REACT_APP_FACEBOOK_APP_ID,
  xfbml: true,
  cookie: true,
  version: 'v16.0',
});

// Initialise Facebook SDK
window.fbAsyncInit = function () {
  window.FB.init(getFacebookConfig());
};

(function (d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);
  js.id = id;
  js.src = '//connect.facebook.net/en_GB/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');

const router = new Router(
  [].concat(
    {
      path: '/',
      action: () => {
        const noRender = { component: null, route: { noNav: true } };
        const authToken = querystring.parse(
          window.location.search.replace('?', '')
        );
        if (authToken.code) {
          return geckoAuth
            .claimCode(authToken.code)
            .then(() => {
              GeckoStore.localStorage.set('jwtToken', null);
              window.location.href = `${process.env.REACT_APP_APP_URL}/`;
              return noRender;
            })
            .catch((e) => console.error(e));
        } else {
          GeckoLocation.goTo('/conversations', {
            filter: CONSTS.FILTER_MY_CONVERSATIONS,
          });
          return noRender;
        }
      },
    },
    routes
  )
);

const tagManagerArgs = {
  gtmId: 'GTM-M9NKXDG',
  dataLayer: {
    page: 'Gecko Chat Home',
  },
};
TagManager.initialize(tagManagerArgs);

const handleLocationChange = (location) => {
  const render = (component) =>
    ReactDOM.render(
      <Provider store={reduxStore}>
        <GeckoGlobal />
        {React.cloneElement(component, { params: GeckoLocation.params })}
      </Provider>,
      document.getElementById('root')
    );

  const renderWithNav = (component) =>
    render(
      <App>
        {React.cloneElement(component, { params: GeckoLocation.params })}
      </App>
    );

  // scroll to top of page on page change.
  window.scrollTo(0, 0);

  router.resolve({ path: location.pathname }).then((result) => {
    if (result === true) {
      return;
    } // render nothing
    if (!result.component) {
      return;
    } // render nothing
    if (result.route.noNav) {
      render(result.component);
    } else {
      renderWithNav(result.component);
    }
  });
};
GeckoLocation.onChange(handleLocationChange);
handleLocationChange(GeckoLocation.history.location);

// Handle screen size changes

const xlQuery = window.matchMedia('(min-width: 1200px)');
const lgQuery = window.matchMedia('(min-width: 992px)');
const mdQuery = window.matchMedia('(min-width: 768px)');
const smQuery = window.matchMedia('(min-width: 576px)');
const xsQuery = window.matchMedia('(min-width: 0px)');
const setScreenSize = () => {
  if (xlQuery.matches) {
    return reduxStore.dispatch({ type: 'SET_SCREEN_SIZE', payload: 'xl' });
  }
  if (lgQuery.matches) {
    return reduxStore.dispatch({ type: 'SET_SCREEN_SIZE', payload: 'lg' });
  }
  if (mdQuery.matches) {
    return reduxStore.dispatch({ type: 'SET_SCREEN_SIZE', payload: 'md' });
  }
  if (smQuery.matches) {
    return reduxStore.dispatch({ type: 'SET_SCREEN_SIZE', payload: 'sm' });
  }
  return reduxStore.dispatch({ type: 'SET_SCREEN_SIZE', payload: 'xs' });
};
xlQuery.addListener(setScreenSize);
lgQuery.addListener(setScreenSize);
mdQuery.addListener(setScreenSize);
smQuery.addListener(setScreenSize);
xsQuery.addListener(setScreenSize);
setScreenSize();
